import React, {Component, Fragment, useEffect, useRef, useState} from 'react'
import Confetti from "react-confetti";


export default function RenderConfetti({context})
{
    const [height, setHeight] = useState(0)

    useEffect(() => {
        setHeight(document.body.scrollHeight)
    }, );

    if(height===0){
        return null
    }

    return (
        <Confetti
            height={height}
            numberOfPieces={1000}
        />
    )
}
